
export enum XFlowNotificationTypeCd {
	CHANGE_FEED = 'ChangeFeed',
	EMAIL = 'Email',
	PUB_SUB = 'PubSub'}
